import { Component, inject } from '@angular/core';
import { IconNameType } from '../icons/icon-name-type.enum';
import { RoundIconComponent } from '../round-icon/round-icon.component';
import { ModalService, ModalName } from '../../core/services/modal.service';

@Component({
  selector: 'cwo-image-preview-modal',
  standalone: true,
  imports: [RoundIconComponent],
  templateUrl: './image-preview-modal.component.html',
  styleUrl: './image-preview-modal.component.scss',
})
export class ImagePreviewModalComponent {
  modalService = inject(ModalService);
  iconNameType = IconNameType;
  imageSrc = () => this.modalService.stateForModal(ModalName.ImagePreview)?.imageSrc;

  closeModal() {
    this.modalService.closeModal(ModalName.ImagePreview);
  }
  
}
